import React from 'react';
import { Multiselect, Select } from '@amzn/awsui-components-react-v3';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';
import {findOption, findOptions} from "../reports/utils/buttons";

export class SnapshotsButton extends React.Component {
  getSelected = (snapshots) => {
    if(this.props.multiselect){
      return findOptions(this.props.options, snapshots.map(snapshot => snapshot.id));
    } else {
      return snapshots.length === 1 ? findOption(this.props.options, snapshots[0].id) :
          findOption(this.props.options, this.props.liveSnapshotId);
    }
  };

  render() {
      return (
        <div id="snapshots" className={AccuracyButtonNewStyle}>
          <b> {this.props.text} </b>
          {this.props.multiselect && (
            <Multiselect
              options={this.props.options}
              label={this.props.text}
              onChange={this.props.onChange}
              loading={this.props.loading}
              loadingText={'Fetching Snapshots...'}
              placeholder="Snapshots"
              filteringType={'auto'}
              selectedOptions={this.getSelected(this.props.selected)}
              disabled={this.props.disabled}
              keepOpen={false}
              data-cy={this.props['data-cy']}
              />)
          }
          {!this.props.multiselect && (
            <Select
              options={this.props.options}
              label={this.props.text}
              onChange={this.props.onChange}
              loading={this.props.loading}
              loadingText={'Fetching Snapshots...'}
              placeholder="Snapshots"
              filteringType={'auto'}
              selectedOption={this.getSelected(this.props.selected)}
              disabled={this.props.disabled}
              keepOpen={false}
              data-cy={this.props['data-cy']}
            />
          )}
        </div>
      );
  }

  static defaultProps = {
    'data-cy': 'snapshots-button'
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/snapshots_button.jsx